module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "users__container"
  }, [_c('h2', {
    staticClass: "ui inverted center aligned header"
  }, [_vm._v("Users")]), _vm._v(" "), _vm._l((_vm.users), function(user) {
    return _c('div', {
      key: user.uid,
      staticClass: "ui feed",
      class: {
        'is_active': _vm.isActive(user)
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.changeChannel(user)
        }
      }
    }, [_c('div', {
      staticClass: "event"
    }, [_c('div', {
      staticClass: "label"
    }, [_c('img', {
      attrs: {
        "src": user.avatar,
        "alt": "avatar"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "content"
    }, [_c('span', {
      staticClass: "ui empty circular label connection__label",
      class: {
        'olive': _vm.isOnline(user), 'red': !_vm.isOnline(user)
      }
    }), _vm._v(" " + _vm._s(user.name) + "\n            ")])])])
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4e0a2b6b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sidebar/Users.vue
// module id = 223
// module chunks = 1